import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';
import { imgUrl } from '../utils/imgUrl';
import './Interests.css';

const InterestCard = ({ interest, type, onRespond }) => {
  const navigate = useNavigate();
  const profile = type === 'received' ? interest.from_profile : interest.to_profile;
  if (!profile) return null;

  const age = profile.date_of_birth
    ? Math.floor((new Date() - new Date(profile.date_of_birth)) / (365.25 * 24 * 60 * 60 * 1000))
    : null;

  const photo = profile.photos?.[0]?.photo_url || profile.profile_photo;
  const initials = `${profile.first_name?.[0] || ''}${profile.last_name?.[0] || ''}`;

  const statusColors = { pending: '#f39c12', accepted: '#27ae60', declined: '#e74c3c', cancelled: '#95a5a6' };

  return (
    <div className="ic-card">
      <div className="ic-avatar" onClick={() => navigate(`/profile/${profile.id}`)}>
        {photo ? <img src={imgUrl(photo)} alt={profile.first_name} /> : <span>{initials}</span>}
      </div>
      <div className="ic-info">
        <h3 onClick={() => navigate(`/profile/${profile.id}`)}>{profile.first_name} {profile.last_name}</h3>
        <div className="ic-meta">
          {age && <span>{age} yrs</span>}
          {profile.professional_details?.occupation && <span>{profile.professional_details.occupation}</span>}
          {profile.location?.city && <span>📍 {profile.location.city}</span>}
        </div>
        <span className="ic-status" style={{ color: statusColors[interest.status] }}>
          ● {interest.status.charAt(0).toUpperCase() + interest.status.slice(1)}
        </span>
      </div>
      <div className="ic-actions">
        {type === 'received' && interest.status === 'pending' && (
          <>
            <button className="ic-btn-accept" onClick={() => onRespond(interest.id, 'accepted')}>✓ Accept</button>
            <button className="ic-btn-decline" onClick={() => onRespond(interest.id, 'declined')}>✕ Decline</button>
          </>
        )}
        <button className="ic-btn-view" onClick={() => navigate(`/profile/${profile.id}`)}>View Profile</button>
      </div>
    </div>
  );
};

const Interests = () => {
  const navigate = useNavigate();
  const [tab, setTab] = useState('received');
  const [received, setReceived] = useState([]);
  const [sent, setSent] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([authService.getReceivedInterests(), authService.getSentInterests()])
      .then(([r, s]) => { setReceived(r.data); setSent(s.data); })
      .finally(() => setLoading(false));
  }, []);

  const handleRespond = async (interestId, action) => {
    await authService.respondInterest(interestId, action);
    setReceived(prev => prev.map(i => i.id === interestId ? { ...i, status: action } : i));
  };

  const list = tab === 'received' ? received : sent;

  return (
    <div className="interests-wrapper">
      <div className="interests-header">
        <button className="interests-back" onClick={() => navigate('/dashboard')}>← Back</button>
        <h2>Interests</h2>
        <span />
      </div>

      <div className="interests-tabs">
        <button className={tab === 'received' ? 'active' : ''} onClick={() => setTab('received')}>
          Received {received.filter(i => i.status === 'pending').length > 0 && (
            <span className="badge">{received.filter(i => i.status === 'pending').length}</span>
          )}
        </button>
        <button className={tab === 'sent' ? 'active' : ''} onClick={() => setTab('sent')}>
          Sent
        </button>
      </div>

      <div className="interests-body">
        {loading ? (
          <div className="interests-empty">Loading...</div>
        ) : list.length === 0 ? (
          <div className="interests-empty">
            {tab === 'received' ? 'No interests received yet' : 'No interests sent yet'}
          </div>
        ) : (
          list.map(interest => (
            <InterestCard
              key={interest.id}
              interest={interest}
              type={tab}
              onRespond={handleRespond}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default Interests;
